import React from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

// See http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = props => {
  const { meta: { touched, error } = {}, input, ...rest } = props;
  return (
	<TextField
		error={Boolean(touched && error)}
		helperText={touched && error}
		{...input}
		{...rest}
		fullWidth
    />
  );
};

renderInput.propTypes = {
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
};

export default renderInput;
